import React, { useState } from 'react'
import {
  Row, Col, Button,
} from 'reactstrap'
import colors from 'constants/colors'
import { gql, useQuery } from '@apollo/client'
import { Query, Space } from 'generated/types'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import HourlyHeatMapChart from './HourlyHeatMapChart'
import { useFilters } from './FiltersContext'

const SPACE_HOURLY_COUNT = gql`
  query Space($id: Int!, $startDate: DateTime!, $endDate: DateTime!) {
      chart {
        hourlyUse(spaceId: $id, filters: {startDate: $startDate, endDate: $endDate}) {
          count
          hour
        }
      }
    }
`

const SpaceName = styled.h2`
  font-family: Poppins;
  font-weight: normal;
  font-size: 18px;
  color: #B2B4C2;
`

export const DetailExpandButton = styled(Button)`
    color: white;
    background-color: transparent;
    border-color: transparent;
    font-family: Poppins;
    font-weight: 500;
    font-size: 14px;
    letter-spacing: 0;
    padding: 7px 15px;
    border-radius: 7px;

    &:hover {
      background-color: ${colors.lightGrey};
      border-color: ${colors.lightGrey};
    }
    &:focus {
      background-color: ${colors.lightGrey};
      border-color: ${colors.lightGrey};
    }
    &:active {
      background-color: ${colors.lightGrey} !important;
      border-color: ${colors.lightGrey} !important;
    }
`

const DetailedExpandButtonIcon = styled(FontAwesomeIcon)`
    color: ${colors.secondaryGreen};
`

const CapacityGuage:React.FC<{percent:number}> = ({ percent }) => {
  return (
    <div style={{ backgroundColor: colors.lightGrey, width: '100%', height: 10 }}>
      <div style={{ backgroundColor: colors.primary, width: `${percent}%`, height: 10 }} />
    </div>
  )
}

function percentFromCountAndSpace(count:number, space: Space, days:number = 14) {
  if (!space.capacity) {
    return 0
  }

  return Math.min(((count / days) / space.capacity) * 100, 100)
}

const BusiestSpaceChartDetails: React.FC<{ space: Space, count: number }> = ({ space, count }) => {
  const [filters] = useFilters()
  const [showTimeChart, setShowTimeChart] = useState(false)

  const { data } = useQuery<Query>(SPACE_HOURLY_COUNT, {
    variables: {
      id: space.id,
      startDate: filters.startDate?.toJSDate(),
      endDate: filters.endDate?.toJSDate(),
    },
  })

  const toggleShowTimeChart = () => {
    setShowTimeChart(!showTimeChart)
  }

  return (
    <Row style={{ borderBottom: '1px solid #eee', padding: '25px' }}>
      <Col>
        <Row>
          <Col xs="11">
            <Row key={`space-detail-busy-${space.id}`}>
              <Col xs="5">
                <SpaceName>{space.name} - ({count})</SpaceName>
              </Col>
              <Col xs="5">
                <p className="text-right">Capacity: {space.capacity || '?'}</p>
              </Col>
            </Row>
            <Row>
              <Col>
                <CapacityGuage percent={percentFromCountAndSpace(count, space)} />
              </Col>
            </Row>
          </Col>
          <Col xs="1">
            <DetailExpandButton color="secondary" onClick={toggleShowTimeChart}>
              <DetailedExpandButtonIcon icon={showTimeChart ? 'chevron-down' : 'chevron-right'} />
            </DetailExpandButton>
          </Col>
        </Row>
        {
          showTimeChart && data
          && (
          <Row>
            <Col xs="12" className="mt-3">
              <HourlyHeatMapChart hours={data?.chart.hourlyUse} />
            </Col>
          </Row>
          )
        }
      </Col>
    </Row>
  )
}

export default BusiestSpaceChartDetails
